import { actionTypes } from 'redux-firestore';
import moment from 'moment';

/**
 * ACTION SIGN IN INIT
 */
export const signInInit = () => {
  return (dispatch) => {
    dispatch({ type: 'AUTH_SIGN_IN_INIT' });
  };
};

/**
 * ACTION SIGN IN
 * Set persistance then sign in your with email and password then update user firestore loggedIn
 * @param {object} credentials - user credentials
 */
export const signIn = (credentials) => {
  return async (dispatch, getState, { getFirebase }) => {
    if (
      credentials !== undefined &&
      credentials.email !== undefined &&
      credentials.password !== undefined &&
      credentials.remember !== undefined
    ) {
      dispatch({ type: 'AUTH_SIGN_IN_PENDING' });
      const firebase = getFirebase();
      const firestore = getFirebase().firestore();
      return await firebase
        .auth()
        .setPersistence(
          process.env.REACT_APP_CLIENT_ENV === 'test'
            ? firebase.auth.Auth.Persistence.NONE
            : credentials.remember
            ? firebase.auth.Auth.Persistence.LOCAL
            : firebase.auth.Auth.Persistence.SESSION
        )
        .then(async () => {
          return await firebase
            .login({
              email: credentials.email,
              password: credentials.password,
            })
            .then((auth) => {
              firestore
                .collection('users')
                .doc(auth.user.user.uid)
                .update({
                  loggedIn: moment().utc().format('YYYY-MM-DDTHH:mm:ssZ'),
                });
              dispatch({ type: 'AUTH_SIGN_IN_SUCCESS' });
              return true;
            })
            .catch((err) => {
              throw err;
            });
        })
        .catch((err) => {
          dispatch({ type: 'AUTH_SIGN_IN_ERROR', err });
          return false;
        });
    } else return false;
  };
};

/*
 * ACTION SIGN OUT
 */
export const signOut = () => {
  return async (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    return await firebase
      .logout()
      .then(() => {
        dispatch({ type: 'AUTH_SIGN_OUT_SUCCESS' });
        dispatch({ type: actionTypes.CLEAR_DATA });
        return true;
      })
      .catch((err) => {
        dispatch({ type: 'AUTH_SIGN_OUT_ERROR', err });
        return false;
      });
  };
};

/*
 * ACTION FORGOT PASSWORD INIT
 */
export const forgotPasswordInit = () => {
  return (dispatch) => {
    dispatch({ type: 'AUTH_FORGOT_PASSWORD_INIT' });
  };
};

/*
 * ACTION FORGOT PASSWORD
 * Send password reset email
 */
export const forgotPassword = (credentials) => {
  return async (dispatch, getState, { getFirebase }) => {
    if (credentials !== undefined && credentials.email !== undefined) {
      dispatch({ type: 'AUTH_FORGOT_PASSWORD_PENDING' });
      const firebase = getFirebase();
      await firebase
        .auth()
        .sendPasswordResetEmail(credentials.email)
        .then(() => dispatch({ type: 'AUTH_FORGOT_PASSWORD_SUCCESS' }))
        .catch((err) => dispatch({ type: 'AUTH_FORGOT_PASSWORD_ERROR', err }));
    } else return false;
  };
};

/*
 * ACTION RESET PASSWORD INIT
 */
export const resetPasswordInit = () => {
  return (dispatch, getState, { getFirebase }) => {
    dispatch({ type: 'AUTH_RESET_PASSWORD_INIT' });
  };
};

/*
 * ACTION RESET PASSWORD CHECK
 * Verify password reset oobCode
 */
export const resetPasswordCheck = (credentials) => {
  return async (dispatch, getState, { getFirebase }) => {
    if (credentials !== undefined && credentials.oobCode !== undefined) {
      const firebase = getFirebase();
      await firebase
        .verifyPasswordResetCode(credentials.oobCode)
        .then((email) => dispatch({ type: 'AUTH_RESET_PASSWORD_VALID', email }))
        .catch((err) => dispatch({ type: 'AUTH_RESET_PASSWORD_INVALID', err }));
    } else return false;
  };
};

/*
 * ACTION RESET PASSWORD
 * Verify password reset oobCode then confirm password reset
 */
export const resetPassword = (credentials) => {
  return async (dispatch, getState, { getFirebase }) => {
    if (
      credentials !== undefined &&
      credentials.oobCode !== undefined &&
      credentials.password !== undefined
    ) {
      dispatch({ type: 'AUTH_RESET_PASSWORD_PENDING' });
      const firebase = getFirebase();
      await firebase
        .verifyPasswordResetCode(credentials.oobCode)
        .then(async () => {
          await firebase
            .confirmPasswordReset(credentials.oobCode, credentials.password)
            .then(() => dispatch({ type: 'AUTH_RESET_PASSWORD_SUCCESS' }))
            .catch((err) => {
              throw err;
            });
        })
        .catch((err) => dispatch({ type: 'AUTH_RESET_PASSWORD_ERROR', err }));
    } else return false;
  };
};

/*
 * ACTION WELCOME SET PASSWORD INIT
 */
export const welcomeSetPasswordInit = (data) => {
  return (dispatch) => {
    dispatch({ type: 'AUTH_WELCOME_SET_PASSWORD_INIT', data });
  };
};

/*
 * ACTION WELCOME SET PASSWORD
 * Set password
 */
export const welcomeSetPassword = (credentials) => {
  return async (dispatch, getState, { getFirebase }) => {
    if (
      credentials !== undefined &&
      credentials.email !== undefined &&
      credentials.oobCode !== undefined &&
      credentials.password !== undefined
    ) {
      dispatch({ type: 'AUTH_WELCOME_SET_PASSWORD_PENDING' });
      const firebase = getFirebase();
      const setPassword = firebase.functions().httpsCallable('activateUser');
      await setPassword({
        email: credentials.email,
        oobCode: credentials.oobCode,
        password: credentials.password,
      })
        .then((res) => {
          if (res && res.data && res.data.status === 'success')
            dispatch({ type: 'AUTH_WELCOME_SET_PASSWORD_SUCCESS', res });
          else throw res.data;
        })
        .catch((err) =>
          dispatch({ type: 'AUTH_WELCOME_SET_PASSWORD_ERROR', err })
        );
    } else return false;
  };
};
